import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sysreptor = defineConnector({
  identifier: "sysreptor",
  name: "SysReptor",
  tagLine: "Penetration test reporting",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://your-instance.sysre.pt/api/v1"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up SysReptor",
      items: [
        {
          kind: "markdown",
          content:
            "Open **Your profile → API tokens** in SysReptor and create a token. Enter your instance API URL and the token below. See [API configuration](https://docs.sysreptor.com/cli/configuration).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://your-instance.sysre.pt/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "For self-hosted deployments, use the HTTPS installation URL for the instance and append /api/v1. The official CLI documentation uses https://demo.sysre.pt as its server example.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Create an API token from the SysReptor user API-token page at your installation URL under /users/self/apitokens/, then store the token securely.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://your-instance.sysre.pt/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/pentestusers/self/",
      ...{ method: "GET" },
    }),
  },
});
